import angular from "angular";
import role from "../role";
import core from "../../core/core.module";

angular
    .module('accessControlCrud.roleForm', [role, core])
    .component('roleForm', {
        controller: ['Role', 'notifier', controller],
        template: require('./role-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Role, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.id = null;
        $ctrl.type = $ctrl.resolve.type;
        $ctrl.key = null;
        $ctrl.name = null;
        $ctrl.description = null;
        if ($ctrl.resolve.role) {
            $ctrl.id = $ctrl.resolve.role.id;
            $ctrl.key = $ctrl.resolve.role.key;
            $ctrl.name = $ctrl.resolve.role.name;
            $ctrl.description = $ctrl.resolve.role.description;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            type: $ctrl.type,
            key: $ctrl.key,
            name: $ctrl.name,
            description: $ctrl.description
        };

        let defer = $ctrl.id ? Role.update($ctrl.id, params) :  Role.store(params);

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    params.id = $ctrl.id;
                }
                closeModal(params);
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );

    };

    function closeModal(role) {
        $ctrl.close({$value: {role: role}});
    }

    $ctrl.deleteRole = function () {
        if (!confirm('Вы действительно хотите удалить эту роль?')) {
             return;
        }
        $ctrl.deleteLoading = true;
        Role.delete($ctrl.id).then(
            function () {
                $ctrl.deleteLoading = false;
                closeModal();
                notifier.successNotify('Роль успешно удалена', 3000);
            },
            function (error) {
                $ctrl.deleteLoading = false;
                notifier.errorResponseNotify(error);
            }
        );
    };
}

export default "accessControlCrud.roleForm";


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/role-form/role-form.js